import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/common/constants/routes';
import { IBenefitType, IPocketType } from '@/common/types/general';
import { NestedRoute } from '@/web/components/NestedRoute';
import { MovementsList } from '@/web/components/TransactionList/components/MovementsList/MovementsList';
import { useMovements } from '@/web/hooks/useMovements';
import { PageLayout } from '@/web/layouts/PageLayout/PageLayout';
import {
  Flex,
  FloatingSelectField,
  PageHeader,
} from '@coverflex-tech/hypernova';
import { useLocalSearchParams } from 'expo-router';
import { getYearFilter, getYearsOptions } from './ActivityPage.utils';
import { css } from './ActivityPage.css';

type TLocationState = {
  backRoute?: string;
  pocketType?: IPocketType;
  category?: IBenefitType;
};

export const ActivityPage = () => {
  const { t } = useTranslation();
  const searchParams = useLocalSearchParams<TLocationState>();
  const yearOptions = getYearsOptions();
  const [year, setYear] = useState(yearOptions[0]);

  const { movements, isLoading: isLoadingMovements } = useMovements({
    pocketType: searchParams?.pocketType,
    category: searchParams?.category,
    from: getYearFilter(year).from,
    to: getYearFilter(year).to,
    perPage: 'all',
  });

  return (
    <NestedRoute backRoute={searchParams?.backRoute ?? ROUTES.ROOT}>
      <PageLayout>
        <PageHeader title={t('dashboard.activity.title')} />
        <Flex alignItems="center" gap="md">
          <FloatingSelectField
            id="year"
            className={css.filter}
            value={year}
            label={t('general.labels.filter_by_year')}
            onChange={(_id, value) => value && setYear(value)}
            itemToString={(item) => (item ? `${item}` : '')}
            options={yearOptions}
          />
        </Flex>
        <MovementsList
          movements={movements?.list ?? []}
          hideTitle
          isGrouped
          loading={isLoadingMovements}
        />
      </PageLayout>
    </NestedRoute>
  );
};
